import React, { Component } from 'react';
import { Panel } from 'react-bootstrap'
//Library for cookies
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { apiService } from '../service/Apiservice';
import { withTranslation } from "react-i18next";
class Note extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            openNote: true,
            producstList: ''
        }
    }

    ////////////SELECTION

    selectNote = (event) => {
        const selectedNoteValue = event.currentTarget.getAttribute('id') //TODO value was read from technology.technology value, but I'm not sure such thing exists
        if (selectedNoteValue) {
            this.selectNoteWithValue(selectedNoteValue)
        }
    }

    selectNoteWithValue = (selectedNoteValue) => {
        this.setState({
            openNote: false,
        })

        // Call callback function and say that is selection finish
        this.props.selectDotThree()
        this.props.completeFormNote()

        apiService.fetchPillar(this.props.getLang(), this.props.carID, this.props.selectedBulb, selectedNoteValue)
            .then(resPillar => {
                this.setState({
                    producstList: resPillar.linecard_info
                })

                this.props.getProductsList(resPillar.linecard_info)
            })

        // Passing state are dot finish to allow jumping from dot to dot
        this.props.jumpThree(selectedNoteValue)
    }

    // allComplete = () => {
    //     if (this.props.selectedNote !== '') {
    //         this.setState({ openNote: false })
    //         this.props.completeFormNote(this.props.selectedNote)
    //     }
    // }
    ////////////SELECTION END

    componentWillUpdate() {
        // this.allComplete()

        if (this.props.isCompleteNote) return;
        if (this.props.noteFromURL && this.props.noteFromURL.length > 0) {
            this.selectNoteWithValue(this.props.noteFromURL)
            this.props.resetFromURL()
            return
        }
    }

    render() {
        let isExpanded = this.state.openNote
        let selected = this.props.selectedNote
        let shouldForceRender = this.props && this.props.shouldForceExpand() && !isExpanded
        const { t } = this.props;
        if (!selected && this.props.technologies && this.props.technologies.length === 1) {
            this.selectNoteWithValue(this.props.technologies[0].name)
        } else {
            if (shouldForceRender) {
                this.setState({ openNote: true }) /* selectedNote: '', */
                isExpanded = true;
                selected = ''
            }
        }
        
        return (
            <div>
                <Panel id="collapsible-panel-example-1" expanded={isExpanded} className="row" onToggle={() => { }}>
                    <Panel.Collapse className="col-xs-12">
                        <Panel.Body>
                            <div className="note-panel">
                                <h4>{t("note.chooseTechnology")}</h4>
                                <form onSubmit={this.handleSubmit} >
                                    <div className="note-panel-content">
                                        <ul>
                                            {this.props.technologies.map((technology) =>
                                                <li key={technology.name} className="noteList"><p onClick={this.selectNote} id={technology.name}>{technology.name}</p></li>
                                            )}
                                           
                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </Panel.Body>
                    </Panel.Collapse>
                    {/*Display + or - , toogle openBrand and show minus or plus*/}
                    <div onClick={() => this.setState({ openNote: !isExpanded })} className={(isExpanded) ? "" : "col-xs-12"}>
                        <div className={(isExpanded) ? " accordion-icon ms-icon_minus" : "accordion-icon ms-icon_plus"}>

                        </div>
                        {/* Display or not when accordion expand or colapse , and on change can open or collapse panel*/}
                        <div className={(isExpanded || !this.props.technologies) ? "none" : "display"} >
                            <h4>{t("note.chooseTechnology")}</h4>
                            <p> {selected} <span className="change" onClick={() => this.setState({ openNote: !isExpanded })}> {t("note.change")}</span></p>
                        </div>
                    </div>
                </Panel>
            </div>
        )
    }
}

const cookieWrap = withCookies(Note);
export default withTranslation()(cookieWrap);
